<template>
	<v-data-table
		:headers="headers"
		:items="items||[]"
		class="tablaLT1"
    :hide-default-footer="!items || items.length<5"
		:class="dark_t?'dark':''">
		<template v-slot:item="props">
			<tr>	
				<td v-for="(h,i) in headers" :key="i">
					<fs1-span>{{ props.item[h.value] }}</fs1-span>
				</td>
			</tr>
		</template>
		<template v-slot:no-data>
				<v-icon>warning</v-icon>
				Sin Información.
		</template>
	</v-data-table>
</template>

<script>
export default {
  props:['items'],
  data() {
    return {
    	headers: [
				{ text: 'Área',  value: 'organization_name'},
				{ text: 'BCEI',  value: 'critical_asset_names'},
				{ text: 'Repuesto',  value: 'name'},
				{ text: 'Material Number',  value: 'material_numbers'},
				{ text: 'Estado Actual',  value: 'spare_part_type'},
				{ text: 'Posible Estado Nuevo',  value: 'new_state'},
			]
		};
  },
};
</script>
